import { MediatorAction } from '@shared/types/action.interface';

export namespace HeaderActions {
  export class GoBack implements MediatorAction {}
}
